import { cva } from '@/styled-system/css';

export const menuItemRecipe = cva({
  base: {
    'position': 'relative',
    'display': 'block',
    'paddingBlock': 'Menu.Item.padding.vert',
    'paddingInline': 'Menu.Item.padding.horz',
    'transition': {
      _motionReduce: 'none',
      _motionSafe: 'background-color 200ms ease, color 200ms ease',
    },
    'width': '100%',
    'cursor': 'pointer',

    'backgroundColor': {
      base: 'Menu.Item.bg.default',

      _notDisabled: {
        _hover: 'Menu.Item.bg.hover',
        _active: 'Menu.Item.bg.pressed',
      },
    },

    '_notDisabled': {
      _hover: {
        '&:where(a) > [data-c11n-component="Menu.ItemLabel"]': {
          textDecoration: 'underline',
        },
      },
    },

    '_focusVisible': {
      '& > [data-c11n-component="Menu.ItemLabel"]': {
        boxShadow: 'focus',
      },
    },
    '_hover': {
      '& > [data-c11n-component="Menu.ItemLabel"]': {
        boxShadow: 'none',
      },
    },

    '&:has([data-c11n-component="Menu.ItemIcon"])': {
      display: 'grid',
      gridTemplate: `
        "icon label" auto
        "icon meta" auto / auto auto
      `,
      justifyContent: 'start',
      columnGap: 'Menu.Item.gap.leading',
    },
  },
  variants: {
    disabled: {
      true: {
        opacity: 'disabled',
        cursor: 'default',
      },
      false: {},
    },
  },
});
